import React, { Component } from 'react'

class ProgressBar extends Component {
  constructor (props) {
    super(props)
    this.state = {
      percentage: props.percentage
    }
  }
  componentWillReceiveProps (props) {
    if (props.percentage !== this.state.percentage) {
      this.setState({percentage: props.percentage})
    }
  }
  render () {
    return (
      <div className='progress'>
        <div className={['progress-bar progress-bar-striped active ', (this.state.percentage >= 100) ? ' progress-bar-success' : '']} style={{'width': this.state.percentage + '%'}} />
      </div>
    )
  }
}
export default ProgressBar



// WEBPACK FOOTER //
// ./src/components/basic/displays/ProgressBar.js